import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { IconButton } from '@mui/material';
import React, { memo, useCallback, useRef, useState } from 'react';

import { Tooltip } from '~/components/Tooltip';

interface Props {
  text: string;
}

const Component: React.FC<Props> = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleTextCopy = useCallback(async () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    await navigator.clipboard.writeText(text);

    setIsCopied(true);

    timeoutRef.current = setTimeout(() => {
      timeoutRef.current = null;

      setIsCopied(false);
    }, 2000);
  }, [text]);

  return (
    <Tooltip open={isCopied} title="Link copied!">
      <IconButton onClick={handleTextCopy}>
        <FileCopyOutlinedIcon sx={{ color: 'var(--gray-6-color)' }} />
      </IconButton>
    </Tooltip>
  );
};

export const CopyIcon = memo(Component);
